import { TonConnectUIProvider } from '@tonconnect/ui-react';

import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { I18nProvider } from '@/lib/i18n';
import { getTonconnectManifestUrl } from '@/lib/ton/tonconnect';
import { AppRouter } from '@/routes/router';

export default function App(): JSX.Element {
  const manifestUrl = getTonconnectManifestUrl();

  return (
    <ErrorBoundary>
      <TonConnectUIProvider manifestUrl={manifestUrl}>
        <I18nProvider>
          <AppRouter />
        </I18nProvider>
      </TonConnectUIProvider>
    </ErrorBoundary>
  );
}
